import React from 'react';
import { Piano, Drum, Music2, Check } from 'lucide-react';
import { lessonsData } from '../mockData';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';

const Lessons = ({ onBookingClick }) => {
  const iconMap = {
    Piano: Piano,
    Drums: Drum,
    "Marching Band & Orchestral Percussion": Music2
  };

  return (
    <section id="lessons" className="py-24">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Lessons & Pricing
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto">
            Choose your instrument and start your musical journey with personalized instruction for all ages and skill levels
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {lessonsData.map((lesson) => {
            const Icon = iconMap[lesson.instrument];
            return (
              <Card 
                key={lesson.id} 
                className="bg-slate-900/80 border-indigo-500/30 hover:border-indigo-400/50 transition-all hover:shadow-xl hover:shadow-indigo-500/10 group"
              >
                <CardHeader>
                  <div className="flex items-center justify-between mb-4">
                    <div className="p-3 bg-indigo-500/20 rounded-lg group-hover:bg-indigo-500/30 transition-colors">
                      <Icon className="w-8 h-8 text-indigo-400" />
                    </div>
                    <div className="text-right">
                      <p className="text-3xl font-bold text-white">{lesson.price}</p>
                      <p className="text-sm text-slate-400">{lesson.duration}</p>
                    </div>
                  </div>
                  <CardTitle className="text-2xl text-white">{lesson.instrument}</CardTitle>
                  <CardDescription className="text-slate-400 text-base">
                    {lesson.description}
                  </CardDescription>
                </CardHeader>
                
                <CardContent>
                  <div className="mb-4">
                    <p className="text-sm text-slate-500 mb-2">Available Levels:</p>
                    <div className="flex flex-wrap gap-2">
                      {lesson.levels.map((level, idx) => (
                        <Badge 
                          key={idx} 
                          variant="outline" 
                          className="border-indigo-500/30 text-indigo-400 hover:bg-indigo-500/10"
                        >
                          {level}
                        </Badge>
                      ))}
                    </div>
                  </div>
                  
                  <div className="space-y-3 mt-6">
                    {lesson.features.map((feature, idx) => (
                      <div key={idx} className="flex items-start gap-3">
                        <Check className="w-5 h-5 text-indigo-400 flex-shrink-0 mt-0.5" />
                        <span className="text-slate-300">{feature}</span>
                      </div>
                    ))}
                  </div>
                </CardContent>
                
                <CardFooter>
                  <Button 
                    onClick={onBookingClick}
                    className="w-full bg-gradient-to-r from-indigo-600 to-blue-600 hover:from-indigo-700 hover:to-blue-700 text-white transition-all hover:scale-105"
                  >
                    {lesson.instrument === "Marching Band & Orchestral Percussion" 
                      ? "Book Lessons" 
                      : lesson.instrument === "Drums"
                      ? "Book Drum Lessons"
                      : `Book ${lesson.instrument} Lesson`}
                  </Button>
                </CardFooter>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Lessons;